export const initialState = {
  header: { automaticStateTransitionId: null, documentTypeId: null, changed: false }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state);
    default:
      return state;
  }
}

const onInitState = (state, action) => {
  // eslint-disable-next-line no-unused-vars
  const { transitionRules, ...ast } = action.data;

  return {
    ...state,
    header: {
      automaticStateTransitionId: ast.automaticStateTransitionId,
      documentTypeId: ast.documentTypeId,
      fromStateId: ast.fromStateId,
      inactive: ast.inactive,
      changed: false
    }
  };
};

const onHeaderPropertyChanged = (state, action) => {
  const { propertyName, value } = action;
  return {
    ...state,
    header: {
      ...state.header,
      [propertyName]: value,
      fromStateId: propertyName === 'documentTypeId' ? '' : propertyName === 'fromStateId' ? value : state.header.fromStateId,
      changed: true
    }
  };
};

const onHeaderSaved = state => {
  return {
    ...state,
    header: {
      ...state.header,
      changed: false
    }
  };
};
